import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Define the translations with languages side by side
// "": ["",""]
const translations = {
  // HEADER
  Visits: ["Visits", "الزيارات"],
  Settings: ["Settings", "الإعدادات"],
  Registration: ["Book appointment", "احجز موعد"],

  // FRONT DESK
  FrontDesk: ["FRONT DESK", "مكتب الاستقبال"],
  NewPatient: ["New Patient", "مريض جديد"],
  NewAppointmentForm: ["New Appointment Form", "استمارة موعد جديد"],
  Age: ["Age", "السن"],

  // SEARCH BAR
  SearchDatabase: ["Search database", "البحث في قاعدة البيانات"],
  FilterTheResults: ["Filter the results", "تصفية النتائج"],
  SearchBy: ["Search by", "البحث بواسطة"],

  // TABLE HEADERS
  ID: ["ID", "رقم الهوية"],
  NewVisit: ["New Visit", "زيارة جديدة"],
  MRN: ["MRN", "الرقم الطبي"],
  Phone: ["Phone", "الهاتف"],
  DOB: ["DOB", "تاريخ الميلاد"],
  Gender: ["⚤", "النوع"],
  GenderHome: ["Gender", "النوع"],
  Name: ["Name", "الاسم"],
  District: ["District", "المنطقة"],
  MrkSource: ["Mrk Source", "مصدر التسويق"],
  Attend: ["Attend", "حضور"],
  Actions: ["Actions", "الإجراءات"],
  Address: ["Address", "العنوان"],
  RegDate: ["RegDate", "تاريخ التسجيل"],
  MedCover: ["MedCover", "التأمين"],
  MrkRN: ["MrkRN", "رقم التسويق"],
  MrkSourceRN: ["MrkSourceRN", "الرقم التسويقي"],

  // Pagination
  Next: ["Next", "التالي"],
  Previous: ["Previous", "السابق"],

  // COMMON BUTTONS
  Save: ["Save", "حفظ"],
  Cancel: ["Cancel", "إلغاء"],
  Close: ["Close", "إغلاق"],
  Less: ["Less", "أقل"],
  More: ["More", "المزيد"],

  // SERVICES
  Services: ["Services", "الخدمات"],
  Fluids: ["Fluids", "المحاليل"],
  Lab: ["Lab. services", "خدمات المعمل"],
  ECG: ["ECG", "رسم القلب"],
  Others: ["Others", "أخرى"],
  Consultation: ["Consultation", "كشف"],
  Nebulizer: ["Nebulizer", "جلسة بخار"],
  Revisit: ["Revisit", "استشارة"],
  Sonar: ["Sonar", "سونار"],
  EditServicePrices: ["Edit Service Prices", "تعديل أسعار الخدمات"],
  EnterServicePrices: ["Enter service prices", "أدخل أسعار الخدمات"],
  Radio: ["Radio", "أشعة"],
  HomeVisit: ["Home Visit", "كشف منزلي"],
  GeneralCheckUp: ["Check up", "فحص عام"],
  HomeUltrasound: ["Ultrasound", "موجات صوتية منزلي"],
  Unpaid: ["Unpaid", "غير مسدد"],

  // COMMON
  Date: ["Date", "التاريخ"],
  Time: ["Time", "الوقت"],
  VisitType: ["Visit type", "نوع الزيارة"],
  Select: ["Select...", "اختر..."],
  Years: ["Years", "سنوات"],
  Months: ["Months", "شهور"],
  TotalPrice: ["Total Price", "الإجمالي"],
  DateFormat: ["en-US", "ar-EG"],
  Edit: ["Edit", "تعديل"],
  Delete: ["Delete", "مسح"],
  SureToDelete: [
    "Are you sure you want to delete this",
    "هل أنت متأكد من المسح",
  ],
  Add: ["Add", "إضافة"],
  Currency: ["£", "ج"],
  First: ["First", "الأول"],
  Last: ["Last", "الأخير"],
  Notes: ["Notes", "ملاحظات"],
  New: ["New", "جديد"],
  SelectLanguage: ["Select language", "اختر اللغة"],
  CurrentLanguage: ["Current language", "اللغة الحالية"],
  Male: ["♂", "ذكر"],
  MaleHome: ["Male", "ذكر"],
  Female: ["♀", "أنثى"],
  FemaleHome: ["Female", "أنثى"],
  Finish: ["Finish", "إتمام العملية"],
  NumberOfRows: ["Number of rows", "عدد الصفوف"],
  Go: ["Go", "بحث"],
  UploadToFile: ["Upload to file", "تحديث الملف الطبي"],

  // Camera
  SelectCamera: ["Select Camera", "اختر الكاميرا"],
  StartCamera: ["Start Camera", "تشغيل الكاميرا"],
  StopCamera: ["Stop Camera", "إيقاف الكاميرا"],
  CaptureImage: ["Capture Image", "التقاط صورة"],
  TransformedImage: ["Transformed Image", "الصورة المعدلة"],
  SaveImage: ["Save Image", "حفظ"],
  SelectPhoto: ["Select photo", "اختر الصورة"],
  Rotate: ["Rotate", "دوران"],
  SelectImageFromDevice: [
    "Select an image from your device",
    "اختر صورة من جهازك",
  ],
  ImageChosenProceed: [
    "This is the image you selected. Click Save to proceed",
    "تم اختيار هذه الصورة - اضغط على (حفظ) للاستمرار",
  ],
  InvalidQualityValue: [
    "Invalid quality value. Please enter a number between 0 and 1.",
    "اختيار خاطئ - يرجى إدخال رقم عشري من ٠ إلى ١",
  ],
  EnterImageQuality: [
    "Enter image quality (between 0 and 1):",
    "أدخل نسبة جودة الصورة - رقم عشري بين ٠ و ١",
  ],
  ModifiedImageUploaded: [
    "Modified image uploaded successfully",
    "تم حفظ الصورة المعدلة",
  ],
  Size: ["Size", "الحجم"],
  UploadedSuccessfully: ["UploadedSuccessfully", "تم رفع الصور"],

  InvalidPhoneNumber: [
    "Invalid phone number phone number should be 11 figures and starts with network code like 010, 011, 012, 015....",
    "رقم الهاتف غير صحيح - يرجى إدخال رقم مكون من ١١ رقم و يبدأ برمز الشبكة مثل ٠١٠ و ٠١١ و ٠١٢ و ٠١٥ ....",
  ],
  RecordExistOverwrite: [
    "This PT phone already exists. Do you want to continue?",
    "الهاتف مسجل مسبقا - هل ترغب في الاستمرار؟",
  ],
  RecordSuccessfullyUpdated: [
    "Record successfully updated!",
    "تم تحديث البيانات بنجاح",
  ],
  RecordSuccessfullyAdded: ["Record successfully added!", "تم التسجيل بنجاح"],
  RecordNotUpdated: ["Record not updated.", "لم يتم تحديث البيانات"],
  ErrorWritingValue: ["Error writing Value:", "خطأ في كتابة القيمة:"],
  Loading: ["Loading", "جاري التحميل"],

  // Medical file
  PastHistory: ["Past History", "التاريخ المرضي"],

  // Home care
  ServiceType: ["Service type", "نوع الخدمة"],
  HomeCare: ["Home care", "رعاية منزلية"],
  Resgistering: ["Registering your data...", "يتم الآن تسجيل بياناتك..."],
  HomeVisitRegistration: ["Home Visits Reservation", "حجز زيارة منزلية"],
  ClinicVisitRegistration: [
    "Clinic appointment Reservation",
    "حجز خدمات العيادة",
  ],
  AllVisitRegistration: ["Services Reservation", "التسجيل و الحجز"],

  Register: ["Register", "تسجيل"],
  RefreshPageToRegister: [
    "Register another appointment!!!",
    "تسجيل مريض آخر!!!",
  ],
  CallNow: ["Or CALL NOW 01110115999", "زيارة مستعجلة - اتصل 01110115999"],
  ClinicAppointment: ["Clinic Appointment", "موعد بالعيادة"],
  BookAHomeVisitAll: ["Book a Visit", "احجز موعد"],
  BookAHomeVisitClinic: ["Book a clinic appointment", "احجز موعد بالعيادة"],
  BookAHomeVisitHome: ["Book a Home Visit", "احجز زيارة منزلية"],
  AllServices: ["All services", "جميع الخدمات"],
  HomeServices: ["Home services", "الخدمات المنزلية"],

  SelectDate2: ["2) Select Date", "2) اختر اليوم"],
  SelectedDate: ["Selected Date:", "تاريخ الزيارة: "],
  Appointment: ["Appointment", "موعد"],
  SelectedServices: ["Selected services", "الخدمات المختارة"],
  EGP: ["EGP", "جنيه"],
  SelectServices: ["Chose Services", "اختر الخدمات"],
  YouMustChooseAService: [
    "You must select at least one service to complete the process",
    "يجب اختيار خدمة واحدة على الأقل لاستكمال الحجز",
  ],

  // Multi-clinic
  Clinic1: ["Shobra clinic", "عيادة شبرا "],
  Clinic2: ["Aghakhan clinic", "عيادة أغاخان "],
  Clinic3: ["Siwa clinic", "عيادة سيوة"],
  SelectClinic: ["Select clinic ", "اختر العيادة "],
  ScrollingTxt: [
    "This is Elhall clinic. Contact us at 01110115999",
    "عيادات الحال ترحب بكم - للتواصل: ٠١١١٠١١٥٩٩٩",
  ],
  VideoGalleryTitle: ["Youtube channel", "قناة اليوتيوب"],
  CancelRegistration: ["Cancel Appointment", "إلغاء الحجز"],

  Madinaty: ["Madinaty", "مدينتي"],
  FifthInstallment: ["Fifth Installment", "التجمع "],
  Elshorouk: ["Elshorouk", "الشروق"],
  MostakbalCity: ["Mostakbal City", "مدينة المستقبل"],
  ElObour: ["ElObour", "العبور"],

  // chat
  FastingBs: ["Fasting", "سكر صائم"],
  PpBs: ["2 hours after breakfast", "ساعتين بعد الفطار"],
  Notes: ["Notes", "ملحوظة"],
  RandomBs: ["Random blood sugar", "سكر عشوائي"],
  ComposeMsg: ["Compose message", "إنشاء رسالة"],
};

// Function to transform translations into the format i18next expects
const transformTranslations = (translations) => {
  const resources = { en: { translation: {} }, ar: { translation: {} } };
  Object.keys(translations).forEach((key) => {
    resources.en.translation[key] = translations[key][0];
    resources.ar.translation[key] = translations[key][1];
  });
  return resources;
};

// Initialize i18next with the transformed translations
i18n.use(initReactI18next).init({
  lng: localStorage.getItem("language") || "en",
  fallbackLng: "en",
  resources: transformTranslations(translations),
});

export default i18n;
